// extracted by mini-css-extract-plugin
module.exports = {"h1":"mvp_h1__wdyWy","h2":"mvp_h2__pQC_J","text":"mvp_text__NZNEh"};